// Drawers
const Drawers = {
  EXPORT: 'export',
  SEARCH: 'search',
  SETUP: 'setup',
};

export default Drawers;